export const roles = ({
    Admin: 'EUPATIADMIN',
    Patient: 'EUPATIPATIENT',
    Member: 'EUPATIMEMBER'
});